<form [formGroup]="form" class="style-form-default">
  <div
    class="style-input-default marginTop"
    data-text="NM código de usuario (NM, CT) *"
    [ngClass]="{ error: verificateInput('codigo_usuario') }"
  >
    <input
      type="text"
      placeholder="NM código de usuario (NM, CT)"
      formControlName="codigo_usuario"
    />
  </div>
  <div
    class="style-input-default marginTop"
    data-text="Cédula de identidad *"
    [ngClass]="{ error: verificateInput('cedula') }"
  >
    <input
      type="text"
      placeholder="Cédula de identidad"
      formControlName="cedula"
	  ciRif
    />
    <mat-error *ngIf="form.get('cedula').hasError('pattern')"
      >La Cédula es <strong>inválida</strong></mat-error
    >
  </div>
  <div
    class="style-input-default marginTop"
    data-text="Nombres y apellidos *"
    [ngClass]="{ error: verificateInput('nombres_apellidos') }"
  >
    <input
      type="text"
      placeholder="Nombres y apellidos"
      formControlName="nombres_apellidos"
    />
  </div>
  <div
    class="style-input-default marginTop"
    data-text="Cargo *"
    [ngClass]="{ error: verificateInput('cargo') }"
  >
    <input type="text" placeholder="Cargo" formControlName="cargo" />
  </div>
  <div
    class="style-input-default marginTop"
    data-text="Departamento o agencia *"
    [ngClass]="{ error: verificateInput('departamento_agencia') }"
  >
    <input
      type="text"
      placeholder="Departamento o agencia"
      formControlName="departamento_agencia"
    />
  </div>
  <div
    class="style-input-default marginTop"
    data-text="Fecha de ingreso *"
    [ngClass]="{ error: verificateInput('fecha_ingreso') }"
  >
    <input
      type="date"
      placeholder="Fecha de ingreso"
      formControlName="fecha_ingreso"
    />
  </div>
  <div
    class="style-input-default marginTop"
    data-text="Fecha de egreso *"
    [ngClass]="{ error: verificateInput('fecha_egreso') }"
  >
    <input
      type="date"
      placeholder="Fecha de egreso"
      formControlName="fecha_egreso"
    />
  </div>
  <div
    class="style-input-default marginTop"
    data-text="Fecha de activación *"
    [ngClass]="{ error: verificateInput('fecha_activacion') }"
  >
    <input
      type="date"
      placeholder="Fecha de activación"
      formControlName="fecha_activacion"
    />
  </div>
  <div
    class="style-input-default marginTop"
    data-text="Supervisor inmediato *"
    [ngClass]="{ error: verificateInput('supervisor_inmediato') }"
  >
    <input
      type="text"
      placeholder="Supervisor inmediato"
      formControlName="supervisor_inmediato"
    />
  </div>
  <div
    class="style-input-default marginTop"
    data-text="Estado *"
    [ngClass]="{ error: verificateInput('estado') }"
  >
    <input type="text" placeholder="Estado" formControlName="estado" />
  </div>
</form>
